<template>
  <v-container class="pa-0">
    <v-row align="center" justify="center" :style="contentsHeight">
      <v-col cols="6" class="pa-1">
        <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
        <v-toolbar v-if="reset" dark flat color="error">
          <v-spacer></v-spacer>
          <v-toolbar-title>新しいパスワード</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card v-if="reset" class="pa-1">
          <v-row align="center" class="ma-0">
            <v-col cols="12" class="py-0" align="end">
              <small>*</small><small class="error--text font-weight-bold caption">必須</small>
            </v-col>
          </v-row>
          <v-row class="ma-0" align="center">
            <v-col cols="12" align="center">
              <v-form v-model="rules.valid">
                <v-text-field
                  id="password"
                  ref="password"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  prepend-icon="lock"
                  name="password"
                  label="*パスワード"
                  v-model="password"
                  :type="show1 ? 'text' : 'password'"
                  required
                  :rules="[rules.required, rules.min]"
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-text-field
                  id="confirmPassword"
                  ref="confirmPassword"
                  :append-icon="show2 ? 'visibility' : 'visibility_off'"
                  prepend-icon="lock"
                  name="confirmPassword"
                  label="*パスワード（確認）"
                  v-model="confirmPassword"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  :rules="[rules.required, rules.min, rules.password]"
                ></v-text-field>
              </v-form>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn depressed rounded @click.stop="onResetPassword()" :disabled="!rules.valid" color="error">登録</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <div class="text-center">
      <v-dialog v-model="dialog" persistent max-width="360">
        <v-card>
          <v-card-title class="title primary white--text">{{ title }}</v-card-title>
          <v-card-text class="pa-4">{{ message }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded depressed color="primary" @click.native="onGoto('/signin')">LOGIN</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      tospp: false,
      mode: null,
      actionCode: null,
      apiKey: null,
      continueUrl: null,
      lang: null,
      dialog: false,
      reset: false,
      title: null,
      message: null,
      show1: false,
      show2: false,
      password: null,
      confirmPassword: null,
      rules: {
        valid: false,
        emailValid: false,
        required: value => !!value || '必須',
        password: value => value === this.password || 'パスワードが一致しません',
        min: value => (!!value && value.length >= 6) || '最低でも 6文字が必要です'
      }
    }
  },
  computed: {
    ...mapGetters({
      error: 'shared/error',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 40) + 'px;'
    }
  },
  created () {
    this.mode = this.getParameterByName('mode')
    this.actionCode = this.getParameterByName('oobCode')
    this.apiKey = this.getParameterByName('apiKey')
    this.continueUrl = this.getParameterByName('continueUrl')
    this.lang = this.getParameterByName('lang') || 'en'
    switch (this.mode) {
      case 'resetPassword':
        this.handleResetPassword(this.actionCode, this.continueUrl, this.lang)
        break
      case 'verifyEmail':
        this.handleVerifyEmail(this.actionCode, this.continueUrl, this.lang)
        break
      default:
        break
    }
  },
  methods: {
    onGoto (path) {
      this.$nextTick(function () {
        this.goto(this, path)
      })
    },
    onDismissed () {
      this.dialog = false
      this.tospp = false
    },
    getParameterByName (name) {
      // eslint-disable-next-line
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      var results = regex.exec(location.search)
      return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    },
    handleResetPassword () {
      var vm = this
      vm.reset = true
    },
    onResetPassword () {
      var vm = this
      firebase.auth().verifyPasswordResetCode(vm.actionCode).then(function (email) {
        firebase.auth().confirmPasswordReset(vm.actionCode, vm.password).then(function (resp) {
          vm.title = 'パスワード'
          vm.message = '新しいパスワードが設定されました。 ログインボタンからログインしてください。'
          vm.dialog = true
          vm.reset = false
        }).catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
          vm.$store.dispatch('shared/setError', error)
        })
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error)
        vm.$store.dispatch('shared/setError', error)
      })
    },
    handleVerifyEmail () {
      var vm = this
      firebase.auth().applyActionCode(this.actionCode).then(function (resp) {
        vm.title = 'メールアドレス認証'
        vm.message = 'メールアドレスが確認されました。ログインボタンからログインしてください。'
        vm.dialog = true
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error)
        vm.$store.dispatch('shared/setError', error)
        vm.onGoto('/')
      })
    }
  }
}
</script>
